import empresaItau from '../images/empresa-itau.png'
import empresaSegmenta from '../images/empresa-segmenta.png'
import empresaCejam from '../images/empresa-cejam.png'
import empresaSerasa from '../images/empresa-serasa.png'
import empresaCasaJose from '../images/empresa-casa jsoe.png'
import empresaAmazon from '../images/emrpresa-amazon logo.png'

const companies = [
  { src: empresaItau, alt: 'Itaú' },
  { src: empresaSegmenta, alt: 'Segmenta' },
  { src: empresaCejam, alt: 'Cejam' },
  { src: empresaSerasa, alt: 'Serasa' },
  { src: empresaCasaJose, alt: 'Casa José' },
  { src: empresaAmazon, alt: 'Amazon' },
]

const Testimonials = () => {
  const duplicatedCompanies = [...companies, ...companies]

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#f8f9fc] overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full h-[4px] bg-gray-400/60 mb-12"></div>
        <div className="text-center mb-16">
          <p className="text-sm font-semibold tracking-widest uppercase text-[#b51625] mb-3">Confiança</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Empresas que confiam na Art Custom
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Marcas que escolheram qualidade e compromisso
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div className="flex items-center animate-scroll">
              {duplicatedCompanies.map((company, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 px-8 md:px-12"
                >
                  <img
                    src={company.src}
                    alt={company.alt}
                    className="h-16 md:h-20 w-auto object-contain transition-all duration-500"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 25s linear infinite;
          will-change: transform;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  )
}

export default Testimonials
